module.exports = __webpack_public_path__ + "img/img13.2c2144b4.jpg";